import { constants, mediaQueryStyles } from "@newsela/angelou";

const { ui } = constants.colors;

const { breakpoints } = constants;
const { mediaQuery } = mediaQueryStyles;
const { md, xs } = breakpoints.BreakpointNames;

export const logoSvgBaseCss = {
  maxHeight: "32px",
  minHeight: "32px",
  minWidth: "32px",
  "-webkit-min-logical-width": "100px",
  path: {
    fill: ui.white[500],
  },
  [mediaQuery.upTo(md)]: {
    "-webkit-min-logical-width": "32px",
  },
  [mediaQuery.upTo(xs)]: {
    margin: "0 16px 0 0",
  },
};

export const logoMarkCss = {
  ...logoSvgBaseCss,
  display: "block",
  [mediaQuery.downTo(md)]: {
    display: "none",
  },
};
export const logoFullCss = {
  ...logoSvgBaseCss,
  display: "none",
  [mediaQuery.downTo(md)]: {
    display: "block",
    margin: "0 16px 0 0",
  },
};
